import toast from "react-hot-toast";

const errorHandler = (error) => {
  if (error.response) {
    if (error.response.data.msgFa) {
      toast.error(error.response.data.msgFa);
    } else if (error.response.data.messageFa) {
      toast.error(error.response.data.messageFa);
    } else if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  } else {
    toast.error("مشکلی پیش آمده");
    console.log(error);
  }
};

export default errorHandler;
